/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ChangeSetCategory } from './ChangeSetCategory';
import {
    instanceOfChangeSetCategory,
    ChangeSetCategoryFromJSON,
    ChangeSetCategoryFromJSONTyped,
    ChangeSetCategoryToJSON,
} from './ChangeSetCategory';

/**
 * @type ChangesGroupDtoType
 * 
 * @export
 */
export type ChangesGroupDtoType = ChangeSetCategory;


export function ChangesGroupDtoTypeFromJSON(json: any): ChangesGroupDtoType {
    return ChangesGroupDtoTypeFromJSONTyped(json, false);
}

export function ChangesGroupDtoTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangesGroupDtoType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...ChangeSetCategoryFromJSONTyped(json, true) };
    return  ChangeSetCategoryFromJSONTyped(json, true);
}

export function ChangesGroupDtoTypeToJSON(value?: ChangesGroupDtoType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfChangeSetCategory(value)) {
        return ChangeSetCategoryToJSON(value as ChangeSetCategory);
    }

    return {};
}

/**
 * Check if a given object implements the ChangesGroupDtoType interface.
 */
export function instanceOfChangesGroupDtoType(value: any): value is ChangesGroupDtoType {
    if (instanceOfChangeSetCategory(value)) return true;
    return false;
}

